<script setup>
/**
 * Språkknappen på sidene før innlogging - velkomst, innlogging, registrering
 * og oppsett. Der finnes det ingen familie å hente språk fra, så valget ligger
 * på enheten og starter på det nettleseren er satt opp med. Logger man inn,
 * tar familiens språk over; oppretter man en familie, blir valget her
 * familiens første språk.
 */
import { ref } from 'vue'
import { track } from '../lib/analytics'
import { deviceLanguage, setDeviceLanguage, t } from '../lib/i18n'
import { languageName } from '../lib/languages'
import Icon from './Icon.vue'
import LanguagePicker from './LanguagePicker.vue'

const open = ref(false)

function choose(code) {
  setDeviceLanguage(code)
  open.value = false
  // Bare at det ble byttet, ikke til hvilket språk: det holder for å vite om
  // velgeren er verdt å ha stående på forsiden.
  track('sprak-byttet')
}
</script>

<template>
  <button class="lang-btn" :aria-label="t('Velg språk')" @click="open = true">
    <Icon name="globe" :size="17" />
    {{ languageName(deviceLanguage) }}
  </button>

  <LanguagePicker
    v-if="open"
    :current="deviceLanguage"
    @close="open = false"
    @choose="choose"
  />
</template>

<style scoped>
.lang-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 13px;
  border: 1px solid var(--border); border-radius: 999px;
  background: var(--surface); color: var(--muted);
  font: inherit; font-size: 0.85rem; font-weight: 600;
  box-shadow: var(--shadow);
  cursor: pointer;
}
</style>
